import { useEffect, useState } from "react"
import { IconPlusOutline18 as PlusIcon } from "nucleo-ui-outline-18"

import { Button, Dialog, Input } from "@productlane/ui"

import { NucleoFillIconPicker } from "@/components/nucleo-fill-icon-picker"
import { useThreadState } from "@/lib/states/global-state"
import { ThreadsFilter } from "../../threads/filter/threads-filter"
import { ThreadsFilterControl } from "../../threads/filter/threads-filter-control"

/** Filters edit the live inbox filter state; the caller loads and saves them. */
export function EditViewDialog({
	name: initialName,
	icon: initialIcon,
	onSave,
	onCancel,
}: {
	name: string
	icon: string
	onSave: (values: { name: string; icon: string }) => void
	onCancel: () => void
}) {
	const [name, setName] = useState(initialName)
	const [icon, setIcon] = useState(initialIcon)
	const trimmed = name.trim()
	const setIsEditingCustomView = useThreadState(
		(state) => state.setIsEditingCustomView,
	)

	// The dialog shows the filters, so the inbox bar behind it would repeat them.
	useEffect(() => {
		setIsEditingCustomView(true)
		return () => setIsEditingCustomView(false)
	}, [setIsEditingCustomView])

	const save = () => {
		if (trimmed) onSave({ name: trimmed, icon })
	}

	return (
		<Dialog
			isOpen
			onOpenChange={(open) => {
				if (!open) onCancel()
			}}
			title="Edit view"
			footer={
				<>
					<Button variant="ghost" onClick={onCancel}>
						Cancel
					</Button>
					<Button disabled={!trimmed} onClick={save}>
						Save
					</Button>
				</>
			}
		>
			<div className="mt-3 flex flex-col gap-5">
				<div className="flex flex-col gap-1.5">
					<span className="text-xs font-medium text-secondary">Name</span>
					<div className="flex items-start gap-2">
						<NucleoFillIconPicker
							icon={icon}
							onChange={(next) => {
								if (next) setIcon(next)
							}}
							buttonVariant="outline"
							buttonClassName="h-9 w-9 flex-none rounded-lg"
						/>
						<Input
							name="custom-view-name"
							aria-label="View name"
							autoFocus
							value={name}
							maxLength={20}
							className="flex-1"
							inputClassName="h-9 rounded-lg"
							onChange={(e) => setName(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") save()
							}}
						/>
					</div>
				</div>
				<div className="flex flex-col items-start gap-2">
					<span className="text-xs font-medium text-secondary">Filters</span>
					<ThreadsFilterControl embedded />
					<ThreadsFilter
						align="start"
						subPanelSide="right"
						closeOnSelect
						trigger={
							<Button variant="ghost" Icon={PlusIcon}>
								Add filter
							</Button>
						}
					/>
				</div>
			</div>
		</Dialog>
	)
}
